$(document).ready(function () {
    const guaranteeButton = $('#guarantee_button');
    const refreshButton = $('#refresh_button');
    const refreshButtonError = $('#refresh_error_button');
    const errorMessages = $('#error_messages ul');

    function animateLoading() {
        const loadingMessage = document.getElementById("loading_message");
        let dots = 0;

        if (! loadingMessage) return;

        return setInterval(() => {
            dots = (dots + 1) % 4; // Cycle through 0, 1, 2, 3
            loadingMessage.textContent = "Submitting" + ".".repeat(dots);
        }, 500); // Adjust the time interval as needed (500ms for half-second intervals)
    }

    const loadingInterval = animateLoading();

    guaranteeButton.on('click', function (e) {
        e.preventDefault(); // Prevent the form from submitting via a link

        // Get the form input values
        const guaranteeID = $('#guarantee_order_id').val();
        const deliveryPostcode = $('#guaranteeDelivery').val();
        const guaranteeEmail = $('#guaranteeBillingEmail').val();
        // const clientApiKey = '89uy34ndsfg94tudHJERgfhn489t';
        const clientApiKey = document.getElementById('apiKeyContainer').getAttribute('data-api-key');
        console.log(clientApiKey);


        // Get the value of the checkbox
        const exclusiveOffers = $('#exclusiveOffers').is(':checked');

        // Clear previous error messages and hide the error container
        errorMessages.empty();
        $('#error_messages').hide();

        // Show the loading message
        $('#loading_message').show();
        guaranteeButton.css({
            'opacity': 0.8,
            'pointer-events': 'none'
        });
        $('#submit_default').hide();


        // Validate the form input fields
        let hasErrors = false;
        if (!guaranteeID || !deliveryPostcode || !guaranteeEmail) {
            appendErrorMessage("Please complete all fields");
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }

        if (!isValidEmail(guaranteeEmail)) {
            appendErrorMessage("Please enter a valid email address");
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }
        if (guaranteeEmail.length > 320) {
            appendErrorMessage("Email address is too long. Maximum length is 320 characters.");
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }
        if (deliveryPostcode.length > 15) {
            appendErrorMessage("Delivery postcode is too long. Maximum length is 15 characters.");
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }

        if (!hasErrors) {
            // Prepare the data to be sent in the POST request
            const requestData = {
                order_number: guaranteeID,
                town_or_postcode: deliveryPostcode,
                email: guaranteeEmail,
                phone: null,
                marketing_consent: exclusiveOffers
            };

            // Make a POST request to the microservice API
            fetch(`https://app-lj-shipping-charges.azurewebsites.net/SalesOrder/GuarenteeRegistration/${clientApiKey}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            })
                .then(handleResponse)
                .then(data => handleSuccess(data))
                .catch(handleError);
        }
    });


    // Event listener for the refresh button
    refreshButton.on('click', function () {
        location.reload();
    });

    refreshButtonError.on('click', function () {
        location.reload();
    });

    // Function to validate email format
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function appendErrorMessage(message) {
        const errorMessage = `<li>${message}</li>`;
        errorMessages.append(errorMessage);

        if (errorMessages.children().length > 0) {
            $('#error_messages').show();
        } else {
            $('#error_messages').hide();
        }
    }

    // Function to handle the response from the API
    function handleResponse(response) {
        console.log('response::', response)
        if (response.status === 200) {
            return response.json(); // Parse the response JSON for success
        } else if (response.status === 422) {
            return response.json().then(data => {
                // Hide the form
                $('#form_container').hide();
                $('.guarantee_heading').hide();
                $('#error_messages').hide();

                // Ensure the success page is hidden
                $('#success_container').hide();

                // Show the errors
                let showGenericErrorMessage = true;
                if (data.errors) {
                    data.errors.forEach((item) => {
                        if (item.errorCode) {
                            const errorElementId = 'form_error_' + item.errorCode;
                            const errorMessageElement = document.getElementById(errorElementId);
                            if (errorMessageElement) {
                                showGenericErrorMessage = false;
                                $('#' + errorElementId).show();
                            }
                        }
                    });
                }

                if (showGenericErrorMessage) {
                    $('#form_error_generic').show();
                } else {
                    $('#form_error_generic').hide();
                }

                $('#error_container').show();

                throw new Error("Validation Errors");
            });
        } else {
            // Handle other response statuses here
            appendErrorMessage("Technical error: An error occurred while processing the request.");
            throw new Error("Request Failed");
        }
    }

    function handleSuccess(data) {
        console.log('Success:', data);
        // Hide the form container and success container
        $('#form_container').hide();
        $('#success_container').show();
        $('#loading_message').hide();
        $('#submit_default').show();
        $('.guarantee_heading').hide();
        guaranteeButton.css({
            'opacity': 1,
            'pointer-events': 'auto'
        });
    }

    // Function to handle errors
    function handleError(error) {
        // Handle network or other errors
        console.error(error);

        $('#loading_message').hide();
        $('#submit_default').show();
        guaranteeButton.css({
            'opacity': 1,
            'pointer-events': 'auto'
        });

        // Handle errors and show the error container
        $('#error_messages').show();
    }
});